import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Language } from '../../models/language.model';

export const UIActions = createActionGroup({
  source: 'UI',
  events: {
    get_language_list_start: emptyProps(),
    get_language_list_success: props<{ languageList: Language[] }>(),
    get_language_list_fail: props<{ error: any }>()
  }
});
